import { css } from '@firebolt-dev/css'

export function GameDisconnected({ setDisconnected }) {
  return (
    <div
      className='dc'
      css={css`
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .dc-text {
          margin: 0 0 20px;
        }
        .dc-btn {
          background: #3f4d5d;
          padding: 8px 15px;
        }
      `}
    >
      <div className='dc-text'>You were disconnected.</div>
      <div className='dc-btn pointer' onClick={() => setDisconnected(false)}>
        Reconnect
      </div>
    </div>
  )
}
